import React from "react";
import { Link } from "react-router-dom";
import {
  FaCashRegister,
  FaBoxes,
  FaTags,
  FaDollarSign,
  FaUsers,
  FaUserFriends,
} from "react-icons/fa";

const CompShowInicio = () => {
  return (
    <main className="flex items-center justify-center h-screen">
      <div className="w-full max-w-5xl p-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Ventas */}
          <Link
            to="/venta/minorista"
            className="w-full bg-gradient-to-r from-pink-500 to-red-500 shadow-lg rounded-lg p-6 text-center text-white hover:from-red-600 hover:to-pink-600 transition transform hover:scale-105"
          >
            <FaDollarSign className="text-4xl mx-auto mb-2" />
            <h2 className="text-2xl font-semibold mb-2">Ventas</h2>
          </Link>

          {/* Gestión de Stock */}
          <Link
            to="/gestion-stock"
            className="w-full bg-gradient-to-r from-blue-500 to-green-500 shadow-lg rounded-lg p-6 text-center text-white hover:from-green-600 hover:to-blue-600 transition transform hover:scale-105"
          >
            <FaBoxes className="text-4xl mx-auto mb-2" />
            <h2 className="text-2xl font-semibold mb-2">Gestión de Stock</h2>
          </Link>

          {/* Caja */}
          <Link
            to="/caja"
            className="w-full bg-gradient-to-r from-indigo-500 to-blue-500 shadow-lg rounded-lg p-6 text-center text-white hover:from-blue-600 hover:to-indigo-600 transition transform hover:scale-105"
          >
            <FaCashRegister className="text-4xl mx-auto mb-2" />
            <h2 className="text-2xl font-semibold mb-2">Caja</h2>
          </Link>

          {/* Ofertas */}
          <Link
            to="/ofertas"
            className="w-full bg-gradient-to-r from-red-400 to-pink-400 shadow-lg rounded-lg p-6 text-center text-white hover:from-pink-500 hover:to-red-500 transition transform hover:scale-105"
          >
            <FaTags className="text-4xl mx-auto mb-2" />
            <h2 className="text-2xl font-semibold mb-2">Ofertas</h2>
          </Link>

          {/* Vendedores */}
          <Link
            to="/vendedores"
            className="w-full bg-gradient-to-r from-yellow-500 to-orange-500 shadow-lg rounded-lg p-6 text-center text-white hover:from-orange-600 hover:to-yellow-600 transition transform hover:scale-105"
          >
            <FaUsers className="text-4xl mx-auto mb-2" />
            <h2 className="text-2xl font-semibold mb-2">Vendedores</h2>
          </Link>

          {/* Clientes */}
          <Link
            to="/clientes"
            className="w-full bg-gradient-to-r from-purple-500 to-pink-500 shadow-lg rounded-lg p-6 text-center text-white hover:from-pink-600 hover:to-purple-600 transition transform hover:scale-105"
          >
            <FaUserFriends className="text-4xl mx-auto mb-2" />
            <h2 className="text-2xl font-semibold mb-2">CC</h2>
          </Link>
        </div>
      </div>
    </main>
  );
};

export default CompShowInicio;
